import React from "react";
import AmenitiesDetailsNew  from "./amenitiesDetailsNew";

class AmenitiesDetailsParent extends React.Component {
    render() {
        return <AmenitiesDetailsNew />
    }
}
export default AmenitiesDetailsParent;